import TableRow, { Props } from './table-row';

export type TableRowProps<T extends Record<string, any>> = Props<T>;
export default TableRow;
